import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/auth";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/login", { email, password });
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full px-3 py-2.5 rounded border border-slate-300 focus:outline-none focus:ring-2 focus:ring-blue-600 text-sm";

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="w-full max-w-sm bg-white rounded-2xl shadow-xl p-8">
        <div className="w-11 h-11 bg-blue-700 rounded-md flex items-center justify-center text-white font-black text-sm mb-5">SE</div>
        <h1 className="text-xl font-black text-slate-950 tracking-tight mb-1">Owner Login</h1>
        <p className="text-xs text-slate-500 mb-6">SUDHEER ELECTRONIC — enquiry dashboard access</p>

        <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
          <div>
            <label htmlFor="admin-email" className="block text-xs font-bold text-slate-700 uppercase mb-1">Email</label>
            <input id="admin-email" data-testid="admin-login-email-input" type="email" required autoComplete="username"
              className={inputCls} placeholder="you@example.com" value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div>
            <label htmlFor="admin-password" className="block text-xs font-bold text-slate-700 uppercase mb-1">Password</label>
            <input id="admin-password" data-testid="admin-login-password-input" type="password" required autoComplete="current-password"
              className={inputCls} placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          {error && (
            <p className="text-xs font-semibold text-red-600 bg-red-50 border border-red-200 rounded px-3 py-2" data-testid="admin-login-error">
              {error}
            </p>
          )}
          <button type="submit" data-testid="admin-login-submit-button" disabled={loading}
            className="w-full inline-flex items-center justify-center gap-2 py-3 bg-blue-700 hover:bg-blue-600 disabled:opacity-60 text-white font-bold rounded uppercase tracking-wider text-xs transition-colors">
            <Lock size={14} /> {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>

        <Link to="/" data-testid="admin-login-back-link" className="block text-center text-xs text-slate-500 hover:text-blue-700 mt-5 transition-colors">
          &larr; Back to website
        </Link>
      </div>
    </div>
  );
}
